<template>
	<div>
		<AppTooltip position="top" text="Users added by email will be invited to your workspace" :disabled="!isEmailInvitation">
			<ChipLayout class="chip-cont px-1" :class="{ suggestion: isEmailInvitation }" :hasClose="hasClose" @close="$emit('onClose')">
				<template v-if="isEmailInvitation">
					<Col class="email-icon-container flex-centerize mr-1">
						<SIcon name="email-invitation-chip" />
					</Col>
					<div class="name-text reg">{{ isFreeTextEmail ? item : item.email }}</div>
				</template>
				<template v-else>
					<ShareFeatureItemAvatarAndName
						:size="18"
						:item="item"
						:name="itemName"
						:isGroup="isGroup"
						class="avatar-and-name"
						v-if="!isFreeTextEmail"
						:showAutoUpgradeIndication="showAutoUpgradeIndication"
					/>
					<template v-else>
						<SIcon :width="13" :height="13" name="email-user-combo" class="mr-1" />
						<div class="name-text reg">{{ item }}</div>
					</template>
				</template>
			</ChipLayout>
		</AppTooltip>
	</div>
</template>
<script>
import isString from 'lodash/isString';

import { BILLING_LEVEL_HIERARCHY } from '@/components/Billing/billing-service.const';
import AppAvatarService from '@/components/common/AppAvatar/app-avatar-service.js';
import ChipLayout from '@/components/common/ChipLayout.vue';
import ShareFeatureItemAvatarAndName from '@/components/dialogs/ShareFeatureDialog/ShareFeatureItemAvatarAndName.vue';
export default {
	name: 'ChipOfContacts',
	components: { ShareFeatureItemAvatarAndName, ChipLayout },
	props: {
		minimalBillingLevel: { type: String },
		hasClose: { type: Boolean, default: true },
		item: { type: [Object, String], required: true },
	},
	computed: {
		isFreeTextEmail() {
			return isString(this.item);
		},
		showAutoUpgradeIndication() {
			if (!this.minimalBillingLevel || !this.item?.billing_level) {
				return false;
			}
			return BILLING_LEVEL_HIERARCHY.indexOf(this.item.billing_level) < BILLING_LEVEL_HIERARCHY.indexOf(this.minimalBillingLevel);
		},
		itemId() {
			return this.item?.user_id || this.item?.id;
		},
		isGroup() {
			return this.item?.isGroup;
		},
		itemName() {
			if (this.isGroup) {
				return this.item?.name;
			} else {
				return AppAvatarService.getUserFullName(this.item) || this.item.email;
			}
		},
		isSyncedGroupUserSuggestion() {
			return this.item.suggestion;
		},
		isEmailInvitation() {
			return this.isSyncedGroupUserSuggestion || this.isFreeTextEmail;
		},
	},
};
</script>

<style scoped lang="scss">
.chip-cont {
	::v-deep(.v-avatar) {
		.letter {
			font-size: 14px !important;
		}
	}
	&.suggestion {
		background: #dbdee2;
	}
}
.name-text {
	font-size: 12px;
	line-height: 14px;
	color: var(--primary-font-color);
}
.avatar-and-name {
	::v-deep {
		.user-name {
			@extend .name-text;
		}
		.avatar {
			margin-right: 4px !important;
		}
	}
}

.email-icon-container {
	width: 18px;
	height: 18px;
	padding-top: 2px;
	border-radius: 50%;
	background: #f6f8fb;
	border: 1px solid #d6ddea;
}
</style>
